/* tslint:disable */
/* eslint-disable */
/**
 * EcoCerram API
 * EcoCerram API generated from BE
 *
 * The version of the OpenAPI document: 0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserDto } from './UserDto';
import {
    UserDtoFromJSON,
    UserDtoFromJSONTyped,
    UserDtoToJSON,
    UserDtoToJSONTyped,
} from './UserDto';

/**
 * 
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    accessToken?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthResponse
     */
    expiresIn?: number;
    /**
     * 
     * @type {UserDto}
     * @memberof AuthResponse
     */
    user?: UserDto;
}

/**
 * Check if a given object implements the AuthResponse interface.
 */
export function instanceOfAuthResponse(value: object): value is AuthResponse {
    return true;
}

export function AuthResponseFromJSON(json: any): AuthResponse {
    return AuthResponseFromJSONTyped(json, false);
}

export function AuthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'] == null ? undefined : json['accessToken'],
        'expiresIn': json['expiresIn'] == null ? undefined : json['expiresIn'],
        'user': json['user'] == null ? undefined : UserDtoFromJSON(json['user']),
    };
}

export function AuthResponseToJSON(json: any): AuthResponse {
    return AuthResponseToJSONTyped(json, false);
}

export function AuthResponseToJSONTyped(value?: AuthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'expiresIn': value['expiresIn'],
        'user': UserDtoToJSON(value['user']),
    };
}

